module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'auctionList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })]), _vm._v(" "), (_vm.mode == 'edit') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Veiling aanpassen")]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v("Veiling toevoegen")]) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('h2', [_vm._v(_vm._s(_vm.form.title))]) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching) ? _c('div', [(_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Titel:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Afkorting:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.form.abbreviation),
      callback: function($$v) {
        _vm.$set(_vm.form, "abbreviation", $$v)
      },
      expression: "form.abbreviation"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Begin datum:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.form.start),
      callback: function($$v) {
        _vm.$set(_vm.form, "start", $$v)
      },
      expression: "form.start"
    }
  })], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "label": "Eind datum:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.form.end),
      callback: function($$v) {
        _vm.$set(_vm.form, "end", $$v)
      },
      expression: "form.end"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-8"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Beschrijving:"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 10
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Inbrenger commissie percentage:"
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-percentage fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.seller_commission_percentage),
      callback: function($$v) {
        _vm.$set(_vm.form, "seller_commission_percentage", $$v)
      },
      expression: "form.seller_commission_percentage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "type": "number",
      "label": "Cliënt commissie percentage:"
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-percentage fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.form.buyer_commission_percentage),
      callback: function($$v) {
        _vm.$set(_vm.form, "buyer_commission_percentage", $$v)
      },
      expression: "form.buyer_commission_percentage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tafelgeld per kavel:"
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "any"
    },
    model: {
      value: (_vm.form.table_money),
      callback: function($$v) {
        _vm.$set(_vm.form, "table_money", $$v)
      },
      expression: "form.table_money"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-group', {
    attrs: {
      "type": "number",
      "label": "Fotogeld per kavel:"
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fas fa-euro-sign fa-fw"
  })]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "any"
    },
    model: {
      value: (_vm.form.photo_cost),
      callback: function($$v) {
        _vm.$set(_vm.form, "photo_cost", $$v)
      },
      expression: "form.photo_cost"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('auction.billRemarkText')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3
    },
    model: {
      value: (_vm.form.bill_remark_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "bill_remark_text", $$v)
      },
      expression: "form.bill_remark_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('auction.billFooterText')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3
    },
    model: {
      value: (_vm.form.bill_footer_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "bill_footer_text", $$v)
      },
      expression: "form.bill_footer_text"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('auction.overviewRemarkText')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3
    },
    model: {
      value: (_vm.form.overview_remark_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "overview_remark_text", $$v)
      },
      expression: "form.overview_remark_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('auction.overviewFooterText')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3
    },
    model: {
      value: (_vm.form.overview_footer_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "overview_footer_text", $$v)
      },
      expression: "form.overview_footer_text"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('auction.sellerInvoiceEmail')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3
    },
    model: {
      value: (_vm.form.seller_invoice_email_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "seller_invoice_email_text", $$v)
      },
      expression: "form.seller_invoice_email_text"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.$t('auction.buyerInvoiceEmail')
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": 3
    },
    model: {
      value: (_vm.form.buyer_invoice_email_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "buyer_invoice_email_text", $$v)
      },
      expression: "form.buyer_invoice_email_text"
    }
  })], 1)], 1)]), _vm._v(" "), (_vm.mode == 'edit') ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Opslaan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "pull-right",
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Veiling aanmaken"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]) : _vm._e()], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c01c96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/AuctionForm.vue
// module id = 1288
// module chunks = 1